const tabGroups = ['educationCenterInfo', 'hospital', 'department', 'lessonPlace'];

export default tabGroups;
